import { LaunchAd } from "../launchAd.ts";
import { AdSerializer } from "./adSerializer.ts";
import { BaseSerializer } from "./baseSerializer.ts";
import { EngagementActionSerializer } from "./engagementActionSerializer";

export class LaunchAdSerializer extends BaseSerializer {
  public deserialize(payload: any): LaunchAd {
    if (payload.ad) {
      payload.ad = new AdSerializer().deserialize(payload.ad);
    }
    if (payload.my_action) {
      payload.my_action = new EngagementActionSerializer().deserialize(payload.my_action);
    }
    return new LaunchAd(payload);
  }

  public deserializeList(payload: any[]): LaunchAd[] {
    return (payload ?? []).map((p) => this.deserialize(p));
  }
}
